<div class="contenedor authTemplate">
  <div class="row">
    <div class="col-12 col-lg-6 p-5">
      <div class="w-100 h-100 d-flex justify-content-center align-items-center">
        <div class="caja">
          <!-- Default form login -->
          <form class="text-cente" [formGroup]="resetPasswordForm" (ngSubmit)="onSubmit()">
            <div class="titulo">Restaurar contraseña en +Cinemateca</div>

            <!-- Email -->
            <div class="form-group mb-4 text-left">
              <input type="email" class="form-control" placeholder="E-mail" formControlName="email" />

              <ng-container *ngIf="resetPasswordForm.get('email').invalid && resetPasswordForm.get('email').touched">
                <div *ngIf="resetPasswordForm.get('email').errors?.required" class="text-danger">
                  Debe ingresar un correo.
                </div>
                <div *ngIf="resetPasswordForm.get('email').errors?.email" class="text-danger">
                  Debe ingresar un correo válido.
                </div>
              </ng-container>
            </div>

            <!-- Sign in button -->
            <div class="form-group mt-3">
              <button
                class="btn btn-block btn-lg my-4"
                type="submit"
                [ngClass]="{ disabled: !resetPasswordForm.valid }"
              >
                <span *ngIf="cargando" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                <span *ngIf="!cargando">CONFIRMAR</span>
              </button>
            </div>

            <!-- Register -->
            <p>¿No estás registrado? <a href="/registro">Registrarse</a></p>
          </form>
        </div>
      </div>
    </div>

    <div class="col-6 p-0 d-none d-lg-inline">
      <div class="imagen"></div>
      <div class="mosaico"></div>
    </div>
  </div>
</div>
